import React, { useState, forwardRef, useImperativeHandle } from 'react';

import { Box } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IconButton from '@material-ui/core/IconButton';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Slide from '@material-ui/core/Slide';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { useSnackbar } from 'notistack';

import { getListAllAPI, api } from '../../../services';
import { formatMoeda } from '../../../utils';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    // color: theme.palette.grey[500],
    color: 'white',
  },
});

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    // backgroundColor: (props) => props.cor,
    // color: 'white',
    borderRadius: '25px',
    width: '150px',
  },
  btnAtionsDisabled: {
    // backgroundColor: 'rgba(0, 0, 0, 0.12)',
    // color: 'red',
    borderRadius: '25px',
    width: '150px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const RECEITA = 'Receita';
const DESPESA = 'Despesa';
const TRANSFERENCIA = 'Transferência';

const DialogoCategoriaTransacao = forwardRef(
  ({ handleClose, cor = 'green' }, ref) => {
    const [open, setOpen] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [id, setId] = useState(-1);
    const [value, setValue] = React.useState(0);
    const [repetida, setRepetida] = React.useState(false);
    const [tipoTransacao, setTipoTransacao] = useState(TRANSFERENCIA);
    const [descricao, setDescricao] = useState('');
    const [valor, setValor] = useState(0);
    const [conta, setConta] = useState(null);
    const [contaDestino, setContaDestino] = useState(null);
    const [carregando, setCarregando] = useState(false);

    const classes = useStyles();

    const handleCloseDialog = () => {
      setOpen(false);
      handleClose();
    };

    const handleChange = (event) => {
      setValue(parseInt(event.target.value, 10));
    };

    async function getDataResource(id) {
      try {
        const data = await getListAllAPI(
          'transacoes',
          ['id', 'asc'],
          { id: [id] },
          ['conta', 'transacao.conta'],
        );
        if (data.data.length > 0) {
          if (data.data[0].is_transferencia) {
            setDescricao('');
            // setConta(data.data[0].tipo === RECEITA ? data.data[0].conta : data.data[0].transacao.conta);
            // setContaDestino(data.data[0].tipo === RECEITA ? data.data[0].transacao.conta : data.data[0].conta);
            setContaDestino(
              data.data[0].tipo === RECEITA
                ? data.data[0].conta
                : data.data[0].transacao.conta,
            );
            setConta(
              data.data[0].tipo === RECEITA
                ? data.data[0].transacao.conta
                : data.data[0].conta,
            );
            setValor(data.data[0].valor);
            setTipoTransacao(TRANSFERENCIA);
            setRepetida(false);
            setValue(0);
            setCarregando(false);
          } else {
            setDescricao(data.data[0].nome);
            setConta(data.data[0].conta);
            setContaDestino(null);
            setValor(data.data[0].valor);
            setTipoTransacao(data.data[0].tipo === RECEITA ? RECEITA : DESPESA);
            setRepetida(!!data.data[0].grupo_id);
            setValue(0);
            setCarregando(false);
          }
        } else {
          throw 'Esta transação não existe!';
        }
      } catch (erros) {
        enqueueSnackbar(`${erros}`, {
          variant: 'error',
        });
        handleCloseDialog();
      }
    }

    async function handleSalvar() {
      try {
        if (id <= 0) {
          enqueueSnackbar('Nenhuma transação aqui!!!', {
            variant: 'error',
          });
        } else {
          await api.delete(
            `/transacoes/${id}?modoEdicao=${repetida ? value : 0}`,
          );
          setCarregando(false);
          enqueueSnackbar(`${tipoTransacao} excluída com sucesso!`, {
            variant: 'success',
          });
        }
        handleCloseDialog();
      } catch (erros) {
        enqueueSnackbar(`${erros}`, {
          variant: 'error',
        });
        handleCloseDialog();
      }
    }

    useImperativeHandle(ref, () => ({
      handleOpen(id) {
        setCarregando(true);
        getDataResource(id);
        setOpen(true);
        setId(id);
      },
    }));

    function getColor() {
      switch (tipoTransacao) {
        case RECEITA:
          return '#4caf50';
        case DESPESA:
          return '#f44336';
        case TRANSFERENCIA:
          return '#009FD4';
        default:
          return '#009FD4';
      }
    }

    return (
      <div>
        <Dialog
          open={open}
          aria-labelledby="form-dialog-title"
          classes={{ paper: classes.rootDialogo }}
          className={classes.rootDialogo}
          fullWidth
          maxWidth="md"
          TransitionComponent={Transition}
          keepMounted
        >
          <DialogTitle
            id="form-dialog-title"
            onClose={handleCloseDialog}
            style={{ backgroundColor: getColor(), color: 'white' }}
          >
            {`Deletar ${tipoTransacao}`}
          </DialogTitle>
          <DialogContent
            style={{
              padding: '0px 36px 20px',
              margin: '0',
            }}
          >
            {carregando ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <>
                {tipoTransacao !== 'Transferência' ? (
                  <div style={{ display: 'flex', padding: '20px 0px' }}>
                    <div style={{ flex: 1 }}>
                      <div
                        style={{
                          marginBottom: '5px',
                          color: 'rgba(0, 0, 0, 0.54)',
                          fontWeight: '500',
                        }}
                      >
                        Descrição
                      </div>
                      <div style={{}}>{descricao}</div>
                    </div>
                    <div style={{ flex: 1 }}>
                      <div
                        style={{
                          marginBottom: '5px',
                          color: 'rgba(0, 0, 0, 0.54)',
                          fontWeight: '500',
                        }}
                      >
                        Valor
                      </div>
                      <div style={{}}>{formatMoeda(valor)}</div>
                    </div>
                  </div>
                ) : (
                  <div style={{ display: 'flex', padding: '20px 0px' }}>
                    <div style={{ flex: 1 }}>
                      <div
                        style={{
                          marginBottom: '5px',
                          color: 'rgba(0, 0, 0, 0.54)',
                          fontWeight: '500',
                        }}
                      >
                        De
                      </div>
                      {conta && (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Avatar
                            style={{
                              backgroundColor: conta.color,
                              marginRight: '10px',
                              width: '30px',
                              height: '30px',
                            }}
                          >
                            {conta.nome.charAt(0)}
                          </Avatar>
                          {conta.nome}
                        </div>
                      )}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div
                        style={{
                          marginBottom: '5px',
                          color: 'rgba(0, 0, 0, 0.54)',
                          fontWeight: '500',
                        }}
                      >
                        Para
                      </div>
                      {contaDestino && (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Avatar
                            style={{
                              backgroundColor: contaDestino.color,
                              marginRight: '10px',
                              width: '30px',
                              height: '30px',
                            }}
                          >
                            {contaDestino.nome.charAt(0)}
                          </Avatar>
                          {contaDestino.nome}
                        </div>
                      )}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div
                        style={{
                          marginBottom: '5px',
                          color: 'rgba(0, 0, 0, 0.54)',
                          fontWeight: '500',
                        }}
                      >
                        Valor
                      </div>
                      <div style={{}}>{formatMoeda(valor)}</div>
                    </div>
                  </div>
                )}
                {repetida && (
                  <>
                    <div
                      style={{
                        margin: '8px 0px',
                        color: 'rgba(0, 0, 0, 0.87)',
                        fontSize: '20px',
                        fontWeight: 'bold',
                      }}
                    >
                      <div
                        style={{ marginBottom: '5px' }}
                      >{`Atenção esta é uma ${tipoTransacao}.`}</div>
                      <div>Você deseja deletar...</div>
                    </div>
                    <FormControl
                      component="fieldset"
                      style={{ marginBottom: '9px' }}
                    >
                      <RadioGroup
                        aria-label="gender"
                        name="gender1"
                        value={value}
                        onChange={handleChange}
                      >
                        <FormControlLabel
                          value={0}
                          control={<Radio />}
                          label="Somente esta"
                        />
                        <FormControlLabel
                          value={1}
                          control={<Radio />}
                          label="Esta, e as futuras"
                        />
                        <FormControlLabel
                          value={2}
                          control={<Radio />}
                          label={`Todas as ${tipoTransacao}s, incluindo as passadas`}
                        />
                      </RadioGroup>
                    </FormControl>
                  </>
                )}
              </>
            )}
          </DialogContent>
          <DialogActions
            style={{
              padding: '32px 36px 20px',
              margin: '0',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Button
              onClick={handleCloseDialog}
              classes={{
                root: classes.btnAtions,
                disabled: classes.btnAtionsDisabled,
              }}
              variant="outlined"
              /* style={{
              color: cor, borderRadius: '25px', width: '100px',
            }} */
              // disabled={nome === '' || nome.length > 80}
              color="primary"
            >
              Cancelar
            </Button>
            <Box>
              <div className={classes.wrapper}>
                <Button
                  onClick={handleSalvar}
                  classes={{
                    root: classes.btnAtions,
                    disabled: classes.btnAtionsDisabled,
                  }}
                  /* style={{
                backgroundColor: cor, color: 'white', borderRadius: '25px', width: '100px',
              }} */
                  // disabled={nome === '' || nome.length > 80}
                  variant="contained"
                  color="primary"
                  disabled={carregando}
                >
                  Deletar
                </Button>
                {carregando && (
                  <CircularProgress
                    size={24}
                    className={classes.buttonProgress}
                  />
                )}
              </div>
            </Box>
          </DialogActions>
        </Dialog>
      </div>
    );
  },
);

export default DialogoCategoriaTransacao;
